module.exports = __webpack_public_path__ + "img/left.20209cf5.svg";